import APIConfig from "service/network/APIConfig";
import APIService from "service/network/APIService";

/**
 * Federated allergen fuzzy-search — proxies distinct salt names
 * (api-medicine-service /medicine/salts) + own catalog (foods + other)
 * through api-allergy-v2-service. Same envelope shape as the other
 * catalog clients: `{data: [...]}`.
 *
 * Response entries: { id, name, category, source }
 *   source ∈ "salt"    (distinct salt from api-medicine-service)
 *           | "catalog" (own foods/other collection)
 *
 * Drug allergies are recorded SALT-LEVEL — patients react to the active
 * ingredient, not the brand. The picker's search term matches on salt
 * name (not medicine name), and the resulting record has category=Salt.
 */
class AllergenCatalogService {
  constructor() {
    this.apiService = new APIService();
  }

  search(queryString, onResponse, onError) {
    const q = encodeURIComponent((queryString || "").trim());
    const url = APIConfig.allergenCatalog.search.format(q);
    return this.apiService.get(
      url,
      (res) => onResponse((res && res.data) || []),
      onError
    );
  }
}

export default AllergenCatalogService;
